let Summary1980=[
    {"Countryname":" ",
    "OZ":0,
    "ME":308,
    "NU":229,
    "DI":308,
    "HR":176,
    "CO":164,
    "EC":212,
    "OT":0
    }]
export default Summary1980